var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHotelIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#fff",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7349 10.2847C20.0971 9.87419 20.0622 9.24506 19.6568 8.87982L10.7251 0.82855C10.3197 0.463315 9.66972 0.470966 9.27285 0.845798L0.310827 9.30909C-0.0860458 9.68392 -0.105525 10.3122 0.2677 10.7119L0.492391 10.953C0.865159 11.3526 1.4677 11.4003 1.83734 11.0591L2.50711 10.4412V19.4876C2.50711 20.0426 2.94366 20.492 3.48203 20.492H6.97545C7.51382 20.492 7.95037 20.0426 7.95037 19.4876V13.1588H12.4063V19.4876C12.3985 20.0422 12.7837 20.4916 13.3221 20.4916H17.0242C17.5626 20.4916 17.9992 20.0422 17.9992 19.4872V10.5686C17.9992 10.5686 18.1842 10.7355 18.4124 10.9422C18.6402 11.1484 19.1187 10.983 19.481 10.5722L19.7349 10.2847Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotelIcon);
export default __webpack_public_path__ + "static/media/hotel_icon.8d2ab648668ecbcb16b8f38bb9498d0c.svg";
export { ForwardRef as ReactComponent };